<template>
	<div>
    <div class="windowContainer bg-darkgrey px-3 m-5 collapse" id="ticketWindow">
      <h3 class="kne-title">{{$t("Ticket.title")}}</h3>
      <!-- <button class="btn" @click="showValue(ticketInfo.ticketType)">TTTT</button> -->
      <div class="my-1">
        <label for="ticket-type">{{$t("Ticket.lblType")}}</label>
        <regular-select 
          id="ticket-type"
          :value="ticketInfo.ticketType"
          @change="ticketInfo.ticketType = $event"
          :placeholder="$t('Ticket.selectType')">
            <option v-for="(type, index) in ticketOptions" :key="index" :value="type.value">{{type.name}}</option>
        </regular-select>
      </div>

      <div class="my-1">
        <label for="description">{{$t("Ticket.lblDescription")}}</label>
        <regular-textarea
          id="description"
          :value="ticketInfo.ticketUserDescription"
          @input="ticketInfo.ticketUserDescription = $event"
          rows="3">
        </regular-textarea>
      </div>

      <div class="my-1">
        <label for="addressUrl">{{$t("Ticket.lblUrl")}}</label>
        <regular-input
        :disabled="true"
        :value="ticketInfo.ticketUrl"
        type="text">{{copyAddressBarUrl}}</regular-input>
      </div>
      <p class="error">{{errorMessage}}</p>
      <button
        class="float-right mb-3 m-1 btn btn-kne-orange"
        @click="submitTicket()">
        {{$t("Ticket.submit")}}
      </button>
    </div>
	</div>
</template>

<script>
import regularInput from '../basic-components/regularInput.vue'
import regularTextarea from '../basic-components/regularTextarea.vue'
import regularSelect from '../basic-components/regularSelect.vue'

import { db } from '../../../firebase'
import _ from 'lodash'

export default {
  props: {
    ticketOptions: {
      type: Object,
      required: true
    }
  },
	components: {
    regularInput,
    regularTextarea,
    regularSelect
	},

	data () {
		return {
      ticketInfo: {
        ticketUrl: '',
        ticketType: '',
        ticketUserDescription: ''
      },
      ticketNote: {
        noteDate: Date.now(),
        message: '',
        ticketmasterID: '',
        ticketmasterName: '',
        ticketmasterEmail: ''
      },

      errorMessage: '',
      ticketStatus: {
        pending: 'PENDING',
        ongoing: 'ONGOING',
        resolved: 'RESOLVED',
        denied: 'DENIED'
      }
		}
	},

  async created () {
    this.isScreenSmall = window.innerWidth < 800
    await this.$bindAsObject('user', db.ref(`userInfos/${this.companyUID}/${this.uid}`))
  },

	methods: {
    showValue (val) {
      console.log(val)
    },
    onResize: _.debounce(function () {
      this.isScreenSmall = window.innerWidth < 800
    }, 50),

    submitTicket () {
      // Just in case you know
      if (!this.isTicketFilled) return
      const ticketRef = db.ref().child('ticket')

      ticketRef.push({
        creationDate: Date.now(),
        description: this.ticketInfo.ticketUserDescription,
        employeeInfo: {
          company: this.companyUID,
          email: this.email,
          ID: this.uid,
          name: this.setUsername(this.user),
          phone: this.phone
        },
        notes: '',
        resolvedDate: 0,
        status: this.ticketStatus.pending,
        ticketmasterID: '',
        ticketmasterName: '',
        ticketType: this.ticketInfo.ticketType,
        url: this.ticketInfo.ticketUrl
      })

      this.clearTicket()
    },

    setUsername (user) {
      const isFirstNameValid = (typeof user.firstName !== 'undefined' && user.firstName !== '')
      const isLastNameValid = (typeof user.lastName !== 'undefined' && user.lastName !== '')
      let name = ''

      if (!isFirstNameValid || !isLastNameValid) name = this.$store.state.userInfo.name
      else name = `${user.firstName} ${user.lastName}`

      return name
    },

    clearTicket () {
      this.ticketInfo.ticketType = ''
      this.ticketInfo.ticketUserDescription = ''
      this.errorMessage = ''
      this.copyAddressBarUrl
    }
  },

	computed: {
		uid () {
      return this.$store.state.user.uid
    },
    name () {
      return this.$store.state.userInfo.name
    },
    email () {
      let email
      email = this.$store.state.userInfo.email || this.$store.state.user.email
      return email
    },
    phone () {
      return this.$store.state.userInfo.phone
    },
    companyUID () {
      return this.$store.state.authorization.company
    },

    copyAddressBarUrl () {
      this.ticketInfo.ticketUrl = window.location.href
      return window.location.href
    },

    isTicketFilled () {
      return (
        this.isTicketTypeSelected === true &&
        this.isTicketUserDescriptionLong === true
      )
    },

    isTicketTypeSelected () {
      if (this.ticketInfo.ticketType === '') {
        this.errorMessage = this.$t('Ticket.errorMessage.reasonError')
        return this.errorMessage
      } else return true
    },

    isTicketUserDescriptionLong () {
      if (this.ticketInfo.ticketUserDescription.length < 20) {
        this.errorMessage = this.$t('Ticket.errorMessage.descriptionError')
        return this.errorMessage
      } else return true
    }
	},

	mounted () {
		this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
	},

	watch: {
	},

  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  }
}
</script>

<style scoped>
  .windowContainer {
    border-radius: 0.5rem;

    position: fixed;
    z-index: 1111;
    bottom: 2.5rem;
    right: 0;
  }

  .error {
    color: rgb(255, 71, 71);
  }
</style>
